export default __webpack_public_path__ + "assets/pptx.fc266e95afba9abd862da4d909e1ad68.png";